import React from 'react';

type ToggleSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, disabled = false }) => (
  <button
    type="button"
    className={`flex items-center w-12 h-6 rounded-full transition-colors duration-200 ${
      disabled ? 'bg-gray-200 cursor-not-allowed' : checked ? 'bg-ow-blue' : 'bg-gray-300'
    }`}
    onClick={() => !disabled && onChange(!checked)}
    disabled={disabled}
    aria-pressed={checked}
    style={{ minWidth: 48, minHeight: 24, padding: 0 }}
  >
    <span
      className={`inline-block w-4 h-4 rounded-full shadow transition-transform duration-200 transform ${
        checked ? 'translate-x-7' : 'translate-x-1'
      } ${disabled ? 'bg-gray-400' : 'bg-white'}`}
    />
  </button>
);

export default ToggleSwitch;
